<template>
  <div class="TitleBox lxn-w100 lxn-border-round lxn-overflow-hidden">
    <div class="TitleBox-wrapper-title lxn-w100 lxn-text" :style="titleStyle" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
      <slot name="title">
      </slot>
    </div>
    <div class="TitleBox-wrapper-body" :style="bodyStyle">
      <slot name="body">
      </slot>
    </div>
    <!-- <div :style="buttonStyle" :class="[$store.getters.language.font, $store.getters.language.directionClass]" class="TitleBox lxn-text-center lxn-w100 lxn-border-round lxn-pos-rel lxn-title"> -->
  </div>
</template>

<script>

export default {
  name: 'TitleBox',
  props: {
    titleBgColor: String,
    bgColor: String,
  },
  data: function() {
    return {
    }
  },
  components: {
  },
  computed: {
    titleStyle: function () {
      var titleStyle = '';
      titleStyle += "background-color: " + this.titleBgColor + ";";
      return titleStyle;
    },
    bodyStyle: function () {
      var bodyStyle = '';
      bodyStyle += "background-color: " + this.bgColor + ";";
      return bodyStyle;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .TitleBox {
    margin-bottom: 14px;
  }
  .TitleBox:last-child {
    margin-bottom: 0;
  }
  .TitleBox-wrapper-title {
    height: 30px;
    line-height: 30px;
    text-indent: 14px;
    color: #ffffff;
  }
  .TitleBox-wrapper-body {
    padding: 14px;
  }
</style>
